import { render, staticRenderFns } from "./RestaurantListSection.vue?vue&type=template&id=7b9fad9e&scoped=true&"
import script from "./RestaurantListSection.vue?vue&type=script&lang=js&"
export * from "./RestaurantListSection.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantListSection.vue?vue&type=style&index=0&id=7b9fad9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9fad9e",
  null
  
)

export default component.exports